module.exports = __webpack_public_path__ + "static/socialproof-promo-popup-a408b7f0ea78eede8017ccd03b1f8627.png";